module.exports = __webpack_public_path__ + "f4fc709f980ac08cacea17a740baa150.png";